import { render } from "./SecurityMfa.vue?vue&type=template&id=099ad5cf"
import script from "./SecurityMfa.vue?vue&type=script&lang=js"
export * from "./SecurityMfa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__